import { getCurrentViewPort } from 'services/utility'
import { GONE_FISHING_URL, WAITING_PAGE_URL, getCurrentEnv } from 'services/utility/constants'

const checkApiUnavailable = ({ statusCode }) => {
  if (statusCode === 'UNAVAILABLE') {
    window.location.assign(WAITING_PAGE_URL)
  }
}

const getRedirectLocation = async (response) => {
  const { status } = response
  switch (status) {
    case 503:
      const { statusCode, statusMessage } = response.data
      if (statusCode === 500 && statusMessage === 'UNAVAILABLE') {
        return GONE_FISHING_URL
      }
      return '/back-soon'
    case 412:
      const body = await response.json()
      const { redirectUrl } = body
      return redirectUrl
    default:
      return '/back-soon'
  }
}

const checkForErrors = async (response) => {
  response.data = await response.json()
  checkApiUnavailable(response.data || {})
  if (!response.ok) {
    const redirectLoc = await getRedirectLocation(response)
    window.location.assign(redirectLoc)
  }
  return response
}

function getQuimbyHeaders(env, previewDateParam) {
  const headers = {
    'WM_SVC.NAME': 'CXT-TEMPO-RUNTIME',
  }

  if (previewDateParam) {
    headers['WM_SVC.ENV'] = env === 'stage' || env === 'production' ? 'prod-preview' : 'stage-preview'
    headers['WM_CONSUMER.ID'] = env === 'stage' || env === 'production' ? '44be1aee-3d2f-4bf7-96b0-0358b5f8a539' : 'fa1f9bc8-7b03-4c44-a063-370888dd8a4f'
  } else {
    headers['WM_SVC.ENV'] = env === 'stage' || env === 'production' ? 'prod' : 'stage'
    headers['WM_CONSUMER.ID'] = env === 'stage' || env === 'production' ? '44be1aee-3d2f-4bf7-96b0-0358b5f8a539' : 'fa1f9bc8-7b03-4c44-a063-370888dd8a4f'
  }

  return headers
}

const fetchData = async (pageType, pageID, segment_ids = []) => {
  const viewPort = getCurrentViewPort()
  const { search } = document.location
  const queryParams = search.slice(1).split('&')
  let previewDate
  queryParams.forEach((param) => {
    const [key, value] = param.split('=')
    if (key === 'wm_preview_date') {
      previewDate = value
    }
  })
  let viewPortParam = ''
  const pageIdParam = `${pageID ? `&pageId=${pageID}` : ''}`
  const previewDateParam = `${previewDate ? `&previewDate=${previewDate}` : ''
  }`
  switch (viewPort) {
    case 'large':
      viewPortParam = 'tabletOnly'
      break
    case 'small':
      viewPortParam = 'mobileOnly'
      break
    case 'medium':
      viewPortParam = 'mobileOnly'
      break
    default:
      viewPortParam = ''
      break
  }
  const targeting = {}
  if (viewPortParam) {
    targeting.deviceDisplay = viewPortParam
  }
  if (segment_ids.length > 0) {
    targeting.segmentId = segment_ids
  }
  viewPortParam = Object.keys(targeting).length > 0 ? `&targeting=${JSON.stringify(targeting)}` : ''
  const query = `tenant=Asda.com&channel=WWW&pageType=${pageType}${pageIdParam}${viewPortParam}${previewDateParam}`
  const quimbyURL = previewDateParam
    ? `/cmspreview/tempo?${query}`
    : `/cms/tempo?${query}`

  const env = getCurrentEnv()
  const isPreview = !!previewDateParam

  const headers = getQuimbyHeaders(env, isPreview)

  return fetch(quimbyURL, { headers })
    .then(response => checkForErrors(response))
}

export default fetchData



// WEBPACK FOOTER //
// ./services/api/cms.js